// extracted by mini-css-extract-plugin
export default {"popoverWrapper":"Popover_popoverWrapper__eCudY","popoverContent":"Popover_popoverContent__M4EiJ"};